// src/components/chat/sections/CombineWithMine.js
import React from 'react';
import { renderMessages } from '../utils/messageHelpers';
import ComingSoonDisplay from './combineWithMine/ComingSoonDisplay';

const CombineWithMine = ({ messages }) => {
    return (
        <div className="chat-section combine-upload-section">
            <div className="messages-container">
                <div className="messages">
                    {renderMessages(messages)}
                </div>
            </div>

            <ComingSoonDisplay />
        </div>
    );
};

export default CombineWithMine;